import React from 'react'

const GuestsFillIcon = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.77539 1.5C4.81039 1.5 3.21289 3.0975 3.21289 5.0625C3.21289 6.99 4.72039 8.55 6.68539 8.6175C6.74539 8.61 6.80539 8.61 6.85039 8.6175C6.86539 8.6175 6.87289 8.6175 6.88789 8.6175C6.89539 8.6175 6.89539 8.6175 6.90289 8.6175C8.82289 8.55 10.3304 6.99 10.3379 5.0625C10.3379 3.0975 8.74039 1.5 6.77539 1.5Z"
        fill="#575757"
      />
      <path
        d="M10.5851 10.6127C8.49262 9.21766 5.08012 9.21766 2.97262 10.6127C2.02012 11.2502 1.49512 12.1127 1.49512 13.0352C1.49512 13.9577 2.02012 14.8127 2.96512 15.4427C4.01512 16.1477 5.39512 16.5002 6.77512 16.5002C8.15512 16.5002 9.53512 16.1477 10.5851 15.4427C11.5301 14.8052 12.0551 13.9502 12.0551 13.0202C12.0476 12.0977 11.5301 11.2427 10.5851 10.6127Z"
        fill="#575757"
      />
      <path
        d="M15.0174 5.50556C15.1374 6.96056 14.1024 8.23556 12.6699 8.40806C12.6624 8.40806 12.6624 8.40806 12.6549 8.40806H12.6324C12.5874 8.40806 12.5424 8.40806 12.5049 8.42306C11.7774 8.46056 11.1099 8.22806 10.6074 7.80056C11.3799 7.11056 11.8224 6.07556 11.7324 4.95056C11.6799 4.34306 11.4699 3.78806 11.1549 3.31556C11.4399 3.17306 11.7699 3.08306 12.1074 3.05306C13.5774 2.92556 14.8899 4.02056 15.0174 5.50556Z"
        fill="#575757"
      />
      <path
        d="M16.5176 12.4428C16.4576 13.1703 15.9926 13.8003 15.2126 14.2278C14.4626 14.6403 13.5176 14.8353 12.5801 14.8128C13.1201 14.3253 13.4351 13.7178 13.4951 13.0728C13.5701 12.1428 13.1276 11.2503 12.2426 10.5378C11.7401 10.1403 11.1551 9.8253 10.5176 9.5928C12.1751 9.1128 14.2601 9.4353 15.5426 10.4703C16.2326 11.0253 16.5851 11.7228 16.5176 12.4428Z"
        fill="#575757"
      />
    </svg>
  )
}

export default GuestsFillIcon
